import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { composeResolvers } from "@graphql-tools/resolvers-composition";
import { errorMessages } from "@/lib/constants";
import { SUBSCRIPTION_ESTIMATE_ERROR_MESSAGES, CAMPAIGN_CODE_ERROR_REASONS, VOUCHER_CODE_CHECK_ERROR_REASONS } from "@/lib/errors";
import { gql } from "@apollo/client";
import { changePaymentInstrument } from "@/lib/mailTemplate";
import sendEmail from "@/lib/sendEmail";
import { CONTRACTABLE_BUFFER } from "@/lib/constants";
import { isAuthenticated, ownerOnly, sleep, logicaErrorCode, logicaErrorBody, isDateRangeIn, dateFormat } from "./helper";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type PaymentInstrumentValues {\n    card_number: String\n    card_type: String\n  }\n  type PaymentInstrument {\n    values: PaymentInstrumentValues\n  }\n\n  type Entitlement {\n    right_id: Int\n  }\n\n  type Subscription @cacheControl(scope: PRIVATE, maxAge: 0) {\n    subscription_id: ID\n    course_id: Int\n    payment_method_id: Int\n    payment_instrument_id: Int\n    initialTransactionAt: String\n    nextTransactionAt: String\n    status: String\n    course: Course\n    payment_instrument: PaymentInstrument\n    withdraw_at: String\n    trialStartAt: String\n    trialEndAt: String\n    entitlements: [Entitlement]\n    suspend_flag: Boolean\n    init_order_id: Int\n    error: String\n  }\n\n  type OptionsValue {\n    label: String\n    value: String\n  }\n  type FormQuestions {\n    type: String\n    label: String\n    unique: String\n    help_text: String\n    options: [OptionsValue]\n    key_name: String\n    required: Boolean\n  }\n\n  type FormQuestionsResponse {\n    question_id: Int\n    data: [FormQuestions]\n  }\n\n  type SubscriptionCancel @cacheControl(scope: PRIVATE) {\n    course_id: Int\n    status: String\n    withdraw_at: String\n    error: String\n  }\n\n  type FormQuestionAnswer {\n    answer_id: Int\n  }\n\n  type SubscriptionCheckCancelableResponse {\n    cancelable: Boolean\n    subscription: SubscriptionCheckCancelableSubscription\n  }\n\n  type SubscriptionCheckCancelableSubscription {\n    withdraw_at: String\n  }\n\n  type SubscriptionChangePaymentResult {\n    payment_instrument_id: Int\n    error: String\n  }\n\n  type SubscriptionStatusResponse @cacheControl(scope: PRIVATE, maxAge: 0) {\n    is_contractable: Boolean\n    is_contracted: Boolean\n    have_be_contracted: Boolean\n    is_trial_enabled: Boolean\n    subscription: Subscription\n  }\n\n  type SubscriptionEstimate @cacheControl(scope: PRIVATE, maxAge: 0) {\n    subscription: Subscription\n    voucherCode: VoucherCode\n    coursePricings: [CoursePrice]\n    paymentPrice: CoursePrice\n    broadcastDiscountCampaignPrice: CoursePrice\n    campaignPrice: CoursePrice\n    error: String\n  }\n\n  type Query {\n    subscriptions: [Subscription]\n\n    subscriptionOne(id: Int): Subscription\n\n    formQuestions(id: Int): FormQuestionsResponse\n\n    subscriptionCheckCancelable(\n      subscriptionId: Int\n    ): SubscriptionCheckCancelableResponse\n\n    subscriptionStatus(courseId: Int): SubscriptionStatusResponse\n\n    subscriptionEstimate(\n      courseId: Int\n      paymentMethodId: Int\n      couponCode: String\n    ): SubscriptionEstimate\n  }\n\n  type Mutation {\n    subscribe(\n      courseId: Int\n      paymentInstrumentId: Int\n      voucherCode: String\n      campaignCode: String\n      valuePlanTerm: String\n    ): Subscription\n\n    subscriptionCancel(id: Int): SubscriptionCancel\n\n    subscriptionChangePayment(\n      paymentInstrumentId: Int!\n      subscriptionId: Int!\n    ): SubscriptionChangePaymentResult\n\n    formQuestionAnswer(values: String, id: Int): FormQuestionAnswer\n  }\n"])));
export var resolvers = composeResolvers({
  Query: {
    subscriptions: function () {
      var _subscriptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _args, _ref) {
        var _result$subscriptions;

        var req, dataSources, result, subscriptions;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                req = _ref.req, dataSources = _ref.dataSources;
                _context.next = 3;
                return dataSources.subscribe.subscription();

              case 3:
                result = _context.sent;
                //adultFlagでフィルターする
                subscriptions = result === null || result === void 0 ? void 0 : (_result$subscriptions = result.subscriptions) === null || _result$subscriptions === void 0 ? void 0 : _result$subscriptions.filter(function (data) {
                  var _data$course, _data$course$values, _data$entitlements;

                  return (data === null || data === void 0 ? void 0 : (_data$course = data.course) === null || _data$course === void 0 ? void 0 : (_data$course$values = _data$course.values) === null || _data$course$values === void 0 ? void 0 : _data$course$values.adult_flag) === req.adultMode && (data === null || data === void 0 ? void 0 : data.entitlements) && (data === null || data === void 0 ? void 0 : (_data$entitlements = data.entitlements) === null || _data$entitlements === void 0 ? void 0 : _data$entitlements.length) !== 0;
                });
                return _context.abrupt("return", subscriptions);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function subscriptions(_x, _x2, _x3) {
        return _subscriptions.apply(this, arguments);
      }

      return subscriptions;
    }(),
    subscriptionOne: function () {
      var _subscriptionOne = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref2, _ref3) {
        var id, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                id = _ref2.id;
                dataSources = _ref3.dataSources;
                _context2.next = 4;
                return dataSources.subscribe.subscriptionOne(id);

              case 4:
                res = _context2.sent;
                return _context2.abrupt("return", res.subscription);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function subscriptionOne(_x4, _x5, _x6) {
        return _subscriptionOne.apply(this, arguments);
      }

      return subscriptionOne;
    }(),
    formQuestions: function () {
      var _formQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_parent, args, _ref4) {
        var _res$question, _res$question2;

        var dataSources, res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dataSources = _ref4.dataSources;
                _context3.next = 3;
                return dataSources.subscribe.formQuestions(args);

              case 3:
                res = _context3.sent;
                return _context3.abrupt("return", {
                  question_id: res === null || res === void 0 ? void 0 : (_res$question = res.question) === null || _res$question === void 0 ? void 0 : _res$question.question_id,
                  data: res === null || res === void 0 ? void 0 : (_res$question2 = res.question) === null || _res$question2 === void 0 ? void 0 : _res$question2.schema
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function formQuestions(_x7, _x8, _x9) {
        return _formQuestions.apply(this, arguments);
      }

      return formQuestions;
    }(),
    subscriptionCheckCancelable: function () {
      var _subscriptionCheckCancelable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_parent, _ref5, _ref6) {
        var subscriptionId, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                subscriptionId = _ref5.subscriptionId;
                dataSources = _ref6.dataSources;
                _context4.prev = 2;
                _context4.next = 5;
                return dataSources.subscribe.subscriptionCheckCancelable(subscriptionId);

              case 5:
                res = _context4.sent;
                return _context4.abrupt("return", res[subscriptionId]);

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](2);
                console.log("subscribe check cancelable error", _context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 9]]);
      }));

      function subscriptionCheckCancelable(_x10, _x11, _x12) {
        return _subscriptionCheckCancelable.apply(this, arguments);
      }

      return subscriptionCheckCancelable;
    }(),
    subscriptionStatus: function () {
      var _subscriptionStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_parent, _ref7, _ref8) {
        var courseId, dataSources, _res$subscriptions, res, _subscription, getSubscription, subscription;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                courseId = _ref7.courseId;
                dataSources = _ref8.dataSources;
                _context6.prev = 2;
                _context6.next = 5;
                return dataSources.subscribe.subscriptionStatus(courseId);

              case 5:
                res = _context6.sent;
                _subscription = (_res$subscriptions = res.subscriptions) === null || _res$subscriptions === void 0 ? void 0 : _res$subscriptions[0];

                getSubscription = /*#__PURE__*/function () {
                  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(subscriptionId) {
                    var _subscription2;

                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            if (!subscriptionId) {
                              _context5.next = 7;
                              break;
                            }

                            _context5.next = 3;
                            return dataSources.subscribe.subscriptionOne(subscriptionId);

                          case 3:
                            _subscription2 = _context5.sent;
                            return _context5.abrupt("return", _subscription2 === null || _subscription2 === void 0 ? void 0 : _subscription2.subscription);

                          case 7:
                            return _context5.abrupt("return", null);

                          case 8:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function getSubscription(_x16) {
                    return _ref9.apply(this, arguments);
                  };
                }();

                _context6.next = 10;
                return getSubscription(_subscription === null || _subscription === void 0 ? void 0 : _subscription.subscription_id);

              case 10:
                subscription = _context6.sent;
                return _context6.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
                  subscription: subscription
                }));

              case 14:
                _context6.prev = 14;
                _context6.t0 = _context6["catch"](2);
                console.log("subscriptionStatus error", _context6.t0);

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 14]]);
      }));

      function subscriptionStatus(_x13, _x14, _x15) {
        return _subscriptionStatus.apply(this, arguments);
      }

      return subscriptionStatus;
    }(),
    subscriptionEstimate: function () {
      var _subscriptionEstimate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_parent, _ref10, _ref11) {
        var courseId, paymentMethodId, couponCode, dataSources, res, _body$error, _body$error2, body, errorCode, reason, _ref12, code, message;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                courseId = _ref10.courseId, paymentMethodId = _ref10.paymentMethodId, couponCode = _ref10.couponCode;
                dataSources = _ref11.dataSources;
                _context7.prev = 2;
                _context7.next = 5;
                return dataSources.subscribe.estimate(courseId, paymentMethodId, couponCode);

              case 5:
                res = _context7.sent;
                return _context7.abrupt("return", {
                  subscription: res === null || res === void 0 ? void 0 : res.subscription,
                  voucherCode: res === null || res === void 0 ? void 0 : res.voucher_code,
                  coursePricings: res === null || res === void 0 ? void 0 : res.course_pricings,
                  paymentPrice: res === null || res === void 0 ? void 0 : res.payment_pricing,
                  campaigns: res === null || res === void 0 ? void 0 : res.campaigns
                });

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](2);
                console.log("subscriptionEstimate error", _context7.t0);
                body = logicaErrorBody(_context7.t0);
                errorCode = body === null || body === void 0 ? void 0 : (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code;
                reason = body === null || body === void 0 ? void 0 : (_body$error2 = body.error) === null || _body$error2 === void 0 ? void 0 : _body$error2.reason_type;
                _ref12 = function () {
                  if (errorCode === 22001 && reason && VOUCHER_CODE_CHECK_ERROR_REASONS[reason]) {
                    return VOUCHER_CODE_CHECK_ERROR_REASONS[reason];
                  } else if (errorCode === 34001 && reason && CAMPAIGN_CODE_ERROR_REASONS[reason]) {
                    return CAMPAIGN_CODE_ERROR_REASONS[reason];
                  }

                  return {
                    code: errorCode,
                    message: SUBSCRIPTION_ESTIMATE_ERROR_MESSAGES[errorCode] || errorMessages["subscriptionEstimate"]
                  };
                }(), code = _ref12.code, message = _ref12.message;
                return _context7.abrupt("return", {
                  error: "".concat(message, " \u30A8\u30E9\u30FC\u30B3\u30FC\u30C9: ").concat(code)
                });

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 9]]);
      }));

      function subscriptionEstimate(_x17, _x18, _x19) {
        return _subscriptionEstimate.apply(this, arguments);
      }

      return subscriptionEstimate;
    }()
  },
  Mutation: {
    subscribe: function () {
      var _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_parent, _ref13, _ref14) {
        var courseId, paymentInstrumentId, voucherCode, campaignCode, valuePlanTerm, req, dataSources, _req$userToken, course, contractAllowed, res, userId, errorCode;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                courseId = _ref13.courseId, paymentInstrumentId = _ref13.paymentInstrumentId, voucherCode = _ref13.voucherCode, campaignCode = _ref13.campaignCode, valuePlanTerm = _ref13.valuePlanTerm;
                req = _ref14.req, dataSources = _ref14.dataSources;
                _context8.prev = 2;
                _context8.next = 5;
                return dataSources.courses.courseById(courseId);

              case 5:
                course = _context8.sent;
                contractAllowed = isDateRangeIn(course === null || course === void 0 ? void 0 : course.contractable_start_at, course === null || course === void 0 ? void 0 : course.contractable_end_at, {
                  buffer: CONTRACTABLE_BUFFER,
                  default: true
                });

                if (contractAllowed) {
                  _context8.next = 9;
                  break;
                }

                return _context8.abrupt("return", {
                  error: "契約可能期間外のため購入できません。"
                });

              case 9:
                if (!campaignCode) {
                  _context8.next = 13;
                  break;
                }

                console.log("apply couponCode: ".concat(campaignCode));
                _context8.next = 13;
                return dataSources.subscribe.applyCampaign(courseId, campaignCode);

              case 13:
                _context8.next = 15;
                return dataSources.subscribe.subscribe(courseId, paymentInstrumentId, voucherCode);

              case 15:
                res = _context8.sent;
                userId = req === null || req === void 0 ? void 0 : (_req$userToken = req.userToken) === null || _req$userToken === void 0 ? void 0 : _req$userToken.id;
                console.log("########## Subscribe, userId:".concat(userId, ", courseId: ").concat(courseId, " ##########"));
                console.log("subscribe", res);
                console.log("########## Subscribe End ##########");
                _context8.next = 22;
                return sleep(200);

              case 22:
                if (!valuePlanTerm) {
                  _context8.next = 25;
                  break;
                }

                _context8.next = 25;
                return dataSources.terms.agree(valuePlanTerm);

              case 25:
                return _context8.abrupt("return", res.subscription);

              case 28:
                _context8.prev = 28;
                _context8.t0 = _context8["catch"](2);
                console.log("subscribe error", _context8.t0);
                errorCode = logicaErrorCode(_context8.t0);
                return _context8.abrupt("return", {
                  error: "".concat(errorMessages["subscribeExecute"], " \u30A8\u30E9\u30FC\u30B3\u30FC\u30C9: ").concat(errorCode)
                });

              case 33:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[2, 28]]);
      }));

      function subscribe(_x20, _x21, _x22) {
        return _subscribe.apply(this, arguments);
      }

      return subscribe;
    }(),
    subscriptionCancel: function () {
      var _subscriptionCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_parent, _ref15, _ref16) {
        var id, req, dataSources, _req$userToken2, res, userId, _e$extensions, _e$extensions$respons, _e$extensions$respons2, _e$extensions$respons3, message, errorCode;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                id = _ref15.id;
                req = _ref16.req, dataSources = _ref16.dataSources;
                _context9.prev = 2;
                _context9.next = 5;
                return dataSources.subscribe.subscriptionCancel(id);

              case 5:
                res = _context9.sent;
                userId = req === null || req === void 0 ? void 0 : (_req$userToken2 = req.userToken) === null || _req$userToken2 === void 0 ? void 0 : _req$userToken2.id;
                console.log("########## subscriptionCancel, userId:".concat(userId, ", courseId: ").concat(id, " ##########"));
                console.log("subscriptionCancel", res);
                return _context9.abrupt("return", res.subscription);

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9["catch"](2);
                console.log("subscribe cancel error", _context9.t0);
                message = _context9.t0 === null || _context9.t0 === void 0 ? void 0 : (_e$extensions = _context9.t0.extensions) === null || _e$extensions === void 0 ? void 0 : (_e$extensions$respons = _e$extensions.response) === null || _e$extensions$respons === void 0 ? void 0 : (_e$extensions$respons2 = _e$extensions$respons.body) === null || _e$extensions$respons2 === void 0 ? void 0 : (_e$extensions$respons3 = _e$extensions$respons2.error) === null || _e$extensions$respons3 === void 0 ? void 0 : _e$extensions$respons3.message;
                errorCode = logicaErrorCode(_context9.t0);
                return _context9.abrupt("return", {
                  error: "".concat(message, " \u30A8\u30E9\u30FC\u30B3\u30FC\u30C9: ").concat(errorCode)
                });

              case 18:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[2, 12]]);
      }));

      function subscriptionCancel(_x23, _x24, _x25) {
        return _subscriptionCancel.apply(this, arguments);
      }

      return subscriptionCancel;
    }(),
    formQuestionAnswer: function () {
      var _formQuestionAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_parent, _ref17, _ref18) {
        var id, values, dataSources, res;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                id = _ref17.id, values = _ref17.values;
                dataSources = _ref18.dataSources;
                _context10.prev = 2;
                _context10.next = 5;
                return dataSources.subscribe.formQuestionAnswer(id, values);

              case 5:
                res = _context10.sent;
                return _context10.abrupt("return", res.answers);

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](2);
                console.log("form question answer error", _context10.t0);

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[2, 9]]);
      }));

      function formQuestionAnswer(_x26, _x27, _x28) {
        return _formQuestionAnswer.apply(this, arguments);
      }

      return formQuestionAnswer;
    }(),
    subscriptionChangePayment: function () {
      var _subscriptionChangePayment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_parent, args, _ref19) {
        var req, dataSources, _yield$dataSources$su, subscription, _yield$dataSources$pa, paymentInstrument, course, _yield$dataSources$us, user, errorCode;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                req = _ref19.req, dataSources = _ref19.dataSources;
                _context11.prev = 1;
                _context11.next = 4;
                return dataSources.subscribe.subscriptionChangePayment(args);

              case 4:
                _yield$dataSources$su = _context11.sent;
                subscription = _yield$dataSources$su.subscription;
                _context11.next = 8;
                return dataSources.paymentInstruments.paymentInstrument(subscription.payment_instrument_id);

              case 8:
                _yield$dataSources$pa = _context11.sent;
                paymentInstrument = _yield$dataSources$pa.payment_instrument;
                _context11.next = 12;
                return dataSources.courses.courseById(subscription.course_id);

              case 12:
                course = _context11.sent;
                _context11.next = 15;
                return dataSources.user.me();

              case 15:
                _yield$dataSources$us = _context11.sent;
                user = _yield$dataSources$us.user;
                _context11.next = 19;
                return sendEmail(changePaymentInstrument({
                  address: user.mail_address,
                  paymentInstrument: paymentInstrument,
                  course: course
                }, req.adultMode));

              case 19:
                return _context11.abrupt("return", subscription);

              case 22:
                _context11.prev = 22;
                _context11.t0 = _context11["catch"](1);
                console.log("subscribe change payment error", _context11.t0);
                errorCode = logicaErrorCode(_context11.t0);
                return _context11.abrupt("return", {
                  error: "".concat(errorMessages["subscriptionChangePayment"], " \u30A8\u30E9\u30FC\u30B3\u30FC\u30C9: ").concat(errorCode)
                });

              case 27:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[1, 22]]);
      }));

      function subscriptionChangePayment(_x29, _x30, _x31) {
        return _subscriptionChangePayment.apply(this, arguments);
      }

      return subscriptionChangePayment;
    }()
  },
  Subscription: {
    initialTransactionAt: function initialTransactionAt(sub) {
      return dateFormat(sub.initial_transaction_at);
    },
    nextTransactionAt: function nextTransactionAt(sub) {
      return dateFormat(sub.next_transaction_at);
    },
    trialStartAt: function trialStartAt(sub) {
      return dateFormat(sub.trial_start_at);
    },
    trialEndAt: function trialEndAt(sub) {
      return dateFormat(sub.trial_end_at);
    }
  },
  SubscriptionEstimate: {
    broadcastDiscountCampaignPrice: function broadcastDiscountCampaignPrice(_ref20) {
      var coursePricings = _ref20.coursePricings,
          campaigns = _ref20.campaigns;
      // TODO: 本番のAPIが更新されてcourse_pricingsにcampaign情報が入るようになったらcoursePricingsで直接見る
      // 設定されている放送契約割引キャンペーン
      if (!coursePricings && !campaigns) return null;
      var campaign = availableCamapigns(coursePricings, campaigns).find(function (campaign) {
        var _campaign$values;

        return campaign === null || campaign === void 0 ? void 0 : (_campaign$values = campaign.values) === null || _campaign$values === void 0 ? void 0 : _campaign$values.is_broadcast_discount;
      });
      console.log(coursePricings, campaigns);
      if (!campaign) return null;
      var price = coursePricings.find(function (cp) {
        var _cp$campaign;

        var campaignId = (cp === null || cp === void 0 ? void 0 : cp.campaign_id) || (cp === null || cp === void 0 ? void 0 : (_cp$campaign = cp.campaign) === null || _cp$campaign === void 0 ? void 0 : _cp$campaign.campaign_id);
        return Number(campaignId) === Number(campaign === null || campaign === void 0 ? void 0 : campaign.campaign_id);
      });
      return price;
    },
    campaignPrice: function campaignPrice(_ref21) {
      var _paymentPrice$campaig, _paymentPrice$campaig2;

      var paymentPrice = _ref21.paymentPrice;

      // 適用された放送契約割引ではないキャンペーン
      if (paymentPrice !== null && paymentPrice !== void 0 && paymentPrice.campaign && !(paymentPrice !== null && paymentPrice !== void 0 && (_paymentPrice$campaig = paymentPrice.campaign) !== null && _paymentPrice$campaig !== void 0 && (_paymentPrice$campaig2 = _paymentPrice$campaig.values) !== null && _paymentPrice$campaig2 !== void 0 && _paymentPrice$campaig2.is_broadcast_discount)) {
        return paymentPrice;
      }

      return null;
    }
  }
}, {
  "Mutation.subscribe": [isAuthenticated(), ownerOnly()],
  "Mutation.subscriptionCancel": [isAuthenticated(), ownerOnly()],
  "Mutation.subscriptionChangePayment": [isAuthenticated(), ownerOnly()],
  "Mutation.formQuestionAnswer": [isAuthenticated(), ownerOnly()]
});
/**
 * availableCamapigns.
 * estimateAPIの仕様変更対応
 * APIのレスポンスからcampaignsが廃止され、course_pricingsにcampaignが含まれるようになる
 * APIリリース時にエラーにならないようにどちらの場合でも動作するようにする
 * 後に新しい仕様に寄せる
 *
 * @param {} course_pricings
 * @param {} campaigns
 */

function availableCamapigns(coursePricings, campaigns) {
  if (campaigns) return campaigns;
  if (!coursePricings) return [];
  return coursePricings.filter(function (cp) {
    return cp.campaign;
  }).map(function (cp) {
    return cp.campaign;
  });
}